/*
  One Tooth World — mobile bottom nav behaviour (PRD §6.4).
  Search tab opens the search overlay, Cart tab fires OTW.emit('cart:open').
  OTW.bottomNav.hide()/show() are used by the PDP sticky add-to-cart bar.
*/
const OTW = (window.OTW = window.OTW || {});

function nav() {
  return document.querySelector('[data-otw-bottom-nav]');
}

OTW.bottomNav = {
  hide() {
    nav()?.classList.add('is-hidden');
    document.documentElement.classList.add('otw-bottom-nav-hidden');
  },
  show() {
    nav()?.classList.remove('is-hidden');
    document.documentElement.classList.remove('otw-bottom-nav-hidden');
  },
};

document.addEventListener('click', (event) => {
  const search = event.target.closest('[data-otw-search-open]');
  if (search) {
    event.preventDefault();
    if (OTW.search?.open) OTW.search.open(search);
    else OTW.emit?.('search:open', { opener: search });
    return;
  }
  const cart = event.target.closest('.otw-bottom-nav [data-otw-cart-trigger]');
  if (cart && OTW.emit) {
    // otw-ui.js falls back to Dawn's cart drawer, then to /cart
    event.preventDefault();
    OTW.emit('cart:open', { opener: cart });
  }
});
